import api from './api';

const listPillsCategories = query => api.get('/api/pill-categories/', { params: query });

export default {
  listPillsCategories,
};
